'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dUsers$002dPage$0024 from "./presto.-List-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477 from "./presto.-Presto-Router$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$76() {
  this.bo2 = null;
  this.bnU = null;
  this.bnV = false;
  this.bo3 = null;
  this.bo4 = false;
  this.bo7 = null;
  this.bo0 = null;
  this.bo1 = false;
  this.bnW = null;
  this.bnX = false;
  this.bnY = null;
  this.bnZ = false;
  this.bo5 = false;
  this.bo6 = false;
  this.bo2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bo7 = "ListUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$76 as $c_Lpresto_PrestoRouter$$anon$76 };
$p = $c_Lpresto_PrestoRouter$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$76;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$76() {
}
export { $h_Lpresto_PrestoRouter$$anon$76 as $h_Lpresto_PrestoRouter$$anon$76 };
$h_Lpresto_PrestoRouter$$anon$76.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bo2;
});
$p.M = (function() {
  if ((!this.bnV)) {
    this.bnU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnV = true;
  }
  return this.bnU;
});
$p.O = (function() {
  if ((!this.bo4)) {
    this.bo3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bo4 = true;
  }
  return this.bo3;
});
$p.D = (function() {
  return this.bo7;
});
$p.t = (function() {
  if ((!this.bo1)) {
    this.bo0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bo1 = true;
  }
  return this.bo0;
});
$p.N = (function() {
  if ((!this.bnX)) {
    this.bnW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnX = true;
  }
  return this.bnW;
});
$p.Q = (function() {
  if ((!this.bnZ)) {
    this.bnY = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477.$c_Lpresto_PrestoRouter$$anon$77();
    this.bnZ = true;
  }
  return this.bnY;
});
$p.v = (function() {
  if ((!this.bo6)) {
    this.bo5 = false;
    this.bo6 = true;
  }
  return this.bo5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee521) => ((p) => \u03b4scrutinee521))($j_presto$002e$002dList$002dUsers$002dPage$0024.$m_Lpresto_ListUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$76, "presto.PrestoRouter$$anon$76", ({
  OS: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$76 as $d_Lpresto_PrestoRouter$$anon$76 };
//# sourceMappingURL=presto.-Presto-Router$$anon$76.js.map
